import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './SearchFiltersModalV2.module.css';

const QuickFilterCard = props => {
  const { option, selected, iconSrc, onClick } = props;

  if (!option) {
    return null;
  }

  return (
    <button
      type="button"
      className={classNames(css.quickCard, {
        [css.quickCardSelected]: selected,
      })}
      onClick={onClick}
    >
      {iconSrc ? <img className={css.quickCardIcon} src={iconSrc} alt="" /> : null}
      <span className={css.quickCardLabel}>{option.label}</span>
    </button>
  );
};

QuickFilterCard.defaultProps = {
  selected: false,
  iconSrc: null,
};

QuickFilterCard.propTypes = {
  option: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
  selected: PropTypes.bool,
  iconSrc: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default QuickFilterCard;
